import React from 'react';
import { createPortal } from "react-dom";
export const Portal = ({ children, el = "div" }) => {
    const [container] = React.useState(document.createElement(el));
    React.useEffect(() => {
        document.body.appendChild(container);
        return () => {
            document.body.removeChild(container);
        };
    }, []);
    return createPortal(children, container);
};